module.exports = __webpack_public_path__ + "img/logo_tanalei.6c85b041.png";